import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration.js';
import relativeTime from 'dayjs/plugin/relativeTime.js';
import timezone from 'dayjs/plugin/timezone.js';
import utc from 'dayjs/plugin/utc.js';

/**
 * Central dayjs bootstrap. Registers every dayjs plugin used across the app
 * exactly once. Import this module for its side effects at the application
 * entry point (`src/index.jsx`) before any component renders.
 *
 * `dayjs.extend()` mutates the global dayjs instance, so registering plugins
 * here makes `.utc()`, `.tz()`, `.from()`, `.duration()` etc. available to all
 * 90+ call sites regardless of which module loaded first — avoiding crashes
 * like "X.add(...).utc is not a function" that occur when a component relies on
 * an unrelated module having extended dayjs earlier (SPAZ2-2998).
 */
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.extend(duration);

export default dayjs;
